import { toggleDisabledAttribute } from '@engine/lib/utility/toggle_disabled_attribute';
var three_d_trx_types = ['#transaction_type_sale3d', '#transaction_type_authorize3d', '#transaction_type_init_recurring_sale3d', '#transaction_type_google_pay', '#transaction_type_apple_pay'];

function mpiIsWithoutFields() {
  var selected_mpi = $('#contract_mpi :selected').val();
  var mpis_without_fields = $('#p_contract_mpi').data('mpis-without-fields');
  var selected_mpi_no_fields = $.inArray(selected_mpi, mpis_without_fields);
  var mpi_is_without_fields = selected_mpi_no_fields !== -1;
  return mpi_is_without_fields;
}

function clearMpiElements() {
  $('#p_contract_mpi_fields input').each(function (index, element) {
    element.value = '';
  });
  $('#p_contract_mpi_fields select').each(function (index, element) {
    element.value = '';
  });

  if (!mpiIsWithoutFields()) {
    $('#contract_mpi').val('');
  }
}

function clearMpiModeElements() {
  $('#p_contract_mpi_mode_fields select').each(function (index, element) {
    element.value = '';
  });
  $('#p_contract_mpi_mode_fields select').trigger('chosen:updated');
}

function hasAtLeastOne3dTransaction() {
  var three_d_trx_types_checked_prop = $.map(three_d_trx_types, function (type) {
    return $(type).is(':checked');
  });
  return three_d_trx_types_checked_prop.indexOf(true) !== -1;
}

function toggleMpi() {
  if (hasAtLeastOne3dTransaction()) {
    $('#p_contract_mpi').show();
  } else {
    clearMpiElements();
    $('#p_contract_mpi').hide();
  }
}

function listenForSelecting3dTransaction() {
  if ($('.contracts #supported_transaction_types').length === 0) {
    return;
  }

  toggleMpi();
  $('#supported_transaction_types').on('click', three_d_trx_types.join(', '), function () {
    toggleMpi();
  });
}

function toggleMpiFields() {
  if ($('#contract_mpi :selected').val() === '' || mpiIsWithoutFields()) {
    $('#p_contract_mpi_fields').hide();
    clearMpiElements();
  } else {
    $('#p_contract_mpi_fields').show();
  }
}

function handleMBGateway() {
  var disabled_attr_value = $('#contract_gateway').val() === 'Mbgateway';
  toggleDisabledAttribute($('#feature_supports_reconcile_by_cron'), disabled_attr_value);
}

function handlePayPalGateway() {
  if ($('#contract_gateway').val() === 'PayPal') {
    $('#p_contract_pay_pal_supported_features').show();
    $('#p_contract_pay_pal_platform_fee_in_eur').show();
  } else {
    $('#p_contract_pay_pal_supported_features').hide();
    $('#p_contract_pay_pal_platform_fee_in_eur').hide();
  }
}

function listenForGatewayChange() {
  handlePayPalGateway();

  if ($('#contract_gateway').length) {
    handleMBGateway();
  }

  $('#contract_gateway').on('change', function () {
    handleMBGateway();
    handlePayPalGateway();
  });
}

function listenForMpiChange() {
  if ($('#contract_mpi').length) {
    toggleMpiFields();
  }

  $('#contract_mpi').on('change', function () {
    toggleMpiFields();
  });
}

function toggleMpiModeFields() {
  if ($('#contract_mpi_mode :selected').val() === 'test') {
    $('#p_contract_mpi_mode_fields').show();
  } else {
    clearMpiModeElements();
    $('#p_contract_mpi_mode_fields').hide();
  }
}

function listenForMpiModeChange() {
  if ($('#contract_mpi_mode').length) {
    toggleMpiModeFields();
  }

  $('#contract_mpi_mode').on('change', function () {
    toggleMpiModeFields();
  });
}

function renderBusinessAttributes() {
  var selectedMcc = $('#contract_merchant_category_code :selected').val();
  var merchantId = $('#contract_merchant_id :selected').val();

  if (!selectedMcc || !merchantId) {
    return false;
  }

  $.ajax({
    method: 'GET',
    url: '/contracts/required_business_attributes',
    dataType: 'html',
    data: {
      merchant_id: merchantId,
      merchant_category_code: selectedMcc
    }
  }).done(function (response) {
    $('#required_business_attributes').html($.parseHTML(response));
  });
}

function listenForMccChange() {
  $('#contract_merchant_category_code').on('change', function () {
    renderBusinessAttributes();
  });
}

function listenForMerchantIdChange() {
  $('#contract_merchant_id').on('change', function () {
    renderBusinessAttributes();
  });
}

var Contract = {
  listenForSelecting3dTransaction: listenForSelecting3dTransaction,
  listenForGatewayChange: listenForGatewayChange,
  listenForMpiChange: listenForMpiChange,
  listenForMccChange: listenForMccChange,
  listenForMerchantIdChange: listenForMerchantIdChange,
  listenForMpiModeChange: listenForMpiModeChange
};
export default Contract;